import { render, staticRenderFns } from "./DoubleNumberFrameRoutesViewed.vue?vue&type=template&id=7c8d388e&"
import script from "./DoubleNumberFrameRoutesViewed.vue?vue&type=script&lang=js&"
export * from "./DoubleNumberFrameRoutesViewed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports